export const FLOW_CATEGORY_OPTIONS = [
  { name: "Sign Up", code: "SIGN_UP" },
  { name: "Sign In", code: "SIGN_IN" },
  { name: "Appointment Booking", code: "APPOINTMENT_BOOKING" },
  { name: "Lead Generation", code: "LEAD_GENERATION" },
  { name: "Shopping", code: "SHOPPING" },
  { name: "Contact Us", code: "CONTACT_US" },
  { name: "Customer Support", code: "CUSTOMER_SUPPORT" },
  { name: "Survey", code: "SURVEY" },
  { name: "Other", code: "OTHER" },
];

const DEFAULT_TEMPLATE = {
  version: "7.2",
  screens: [
    {
      id: "WELCOME_SCREEN",
      title: "Welcome",
      terminal: true,
      success: true,
      data: {},
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "TextHeading",
            text: "Hello",
          },
          {
            type: "TextBody",
            text: "Let's start building things!",
          },
          {
            type: "Footer",
            label: "Complete",
            "on-click-action": {
              name: "complete",
              payload: {},
            },
          },
        ],
      },
    },
  ],
};

const COLLECT_PURCHASE_INTEREST_TEMPLATE = {
  version: "7.2",
  screens: [
    {
      id: "JOIN_NOW",
      title: "Join Now",
      data: {},
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "Form",
            name: "form",
            children: [
              {
                type: "TextSubheading",
                text: "Get early access to our Mega Sales Day deals. Register now!",
              },
              {
                type: "TextInput",
                name: "name",
                label: "Name",
                "input-type": "text",
                required: true,
              },
              {
                type: "TextInput",
                label: "Email",
                name: "email",
                "input-type": "email",
                required: true,
              },
              {
                type: "OptIn",
                label: "I agree to the terms.",
                required: true,
                name: "tos_optin",
                "on-click-action": {
                  name: "navigate",
                  payload: {},
                  next: {
                    name: "TERMS_AND_CONDITIONS",
                    type: "screen",
                  },
                },
              },
              {
                type: "OptIn",
                label: "Keep me up to date about offers and promotions",
                name: "marketing_optin",
              },
              {
                type: "Footer",
                label: "Continue",
                "on-click-action": {
                  name: "navigate",
                  next: {
                    type: "screen",
                    name: "CATEGORIES",
                  },
                  payload: {
                    name: "${form.name}",
                    email: "${form.email}",
                    tos_optin: "${form.tos_optin}",
                    marketing_optin: "${form.marketing_optin}",
                  },
                },
              },
            ],
          },
        ],
      },
    },
    {
      id: "CATEGORIES",
      title: "Join now",
      data: {
        name: {
          type: "string",
          __example__: "Example",
        },
        email: {
          type: "string",
          __example__: "Example",
        },
        tos_optin: {
          type: "boolean",
          __example__: false,
        },
        marketing_optin: {
          type: "boolean",
          __example__: false,
        },
      },
      terminal: true,
      success: true,
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "Form",
            name: "form",
            children: [
              {
                type: "TextSubheading",
                text: "Let us know which category you are interested in?",
              },
              {
                type: "CheckboxGroup",
                label: "Select categories",
                required: true,
                name: "categories",
                "data-source": [
                  {
                    id: "mobile_phones",
                    title: "Mobile phones",
                  },
                  {
                    id: "televisions",
                    title: "Televisions",
                  },
                  {
                    id: "home_audio",
                    title: "Home audio",
                  },
                  {
                    id: "headphones",
                    title: "Headphones & earphones",
                  },
                  {
                    id: "ebook_readers",
                    title: "eBook readers",
                  },
                  {
                    id: "cameras",
                    title: "Cameras",
                  },
                  {
                    id: "accessories",
                    title: "Accessories",
                  },
                ],
              },
              {
                type: "Footer",
                label: "Confirm",
                "on-click-action": {
                  name: "complete",
                  payload: {
                    name: "${data.name}",
                    email: "${data.email}",
                    tos_optin: "${data.tos_optin}",
                    marketing_optin: "${data.marketing_optin}",
                    categories: "${form.categories}",
                  },
                },
              },
            ],
          },
        ],
      },
    },
    {
      id: "TERMS_AND_CONDITIONS",
      title: "Terms and conditions",
      data: {},
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "TextHeading",
            text: "Our Terms",
          },
          {
            type: "TextSubheading",
            text: "Data usage",
          },
          {
            type: "TextBody",
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vitae odio dui. Praesent ut nulla tincidunt, scelerisque augue malesuada, volutpat lorem. Aliquam iaculis ex at diam posuere mollis. Suspendisse eget purus ac tellus interdum pharetra. In quis dolor turpis. Fusce in porttitor enim, vitae efficitur nunc. Fusce dapibus finibus volutpat. Fusce velit mi, ullamcorper ac gravida vitae, blandit quis ex. Fusce ultrices diam et justo blandit, quis consequat nisl euismod. Vestibulum pretium est sem, vitae convallis justo sollicitudin non. Morbi bibendum purus mattis quam condimentum, a scelerisque erat bibendum. Nullam sit amet bibendum lectus.",
          },
          {
            type: "TextSubheading",
            text: "Privacy policy",
          },
          {
            type: "TextBody",
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vitae odio dui. Praesent ut nulla tincidunt, scelerisque augue malesuada, volutpat lorem. Aliquam iaculis ex at diam posuere mollis. Suspendisse eget purus ac tellus interdum pharetra. In quis dolor turpis. Fusce in porttitor enim, vitae efficitur nunc. Fusce dapibus finibus volutpat. Fusce velit mi, ullamcorper ac gravida vitae, blandit quis ex. Fusce ultrices diam et justo blandit, quis consequat nisl euismod. Vestibulum pretium est sem, vitae convallis justo sollicitudin non. Morbi bibendum purus mattis quam condimentum, a scelerisque erat bibendum. Nullam sit amet bibendum lectus.",
          },
        ],
      },
    },
  ],
};

const GET_FEEDBACK_TEMPLATE = {
  version: "7.2",
  screens: [
    {
      id: "RECOMMEND",
      title: "Feedback 1 of 2",
      data: {},
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "Form",
            name: "form",
            children: [
              {
                type: "TextSubheading",
                text: "Would you recommend us to a friend?",
              },
              {
                type: "RadioButtonsGroup",
                label: "Choose one",
                name: "Choose_one",
                "data-source": [
                  {
                    id: "0_Yes",
                    title: "Yes",
                  },
                  {
                    id: "1_No",
                    title: "No",
                  },
                ],
                required: true,
              },
              {
                type: "TextSubheading",
                text: "How could we do better?",
              },
              {
                type: "TextArea",
                label: "Leave a comment",
                required: false,
                name: "Leave_a_comment",
              },
              {
                type: "Footer",
                label: "Continue",
                "on-click-action": {
                  name: "navigate",
                  next: {
                    type: "screen",
                    name: "RATE",
                  },
                  payload: {
                    screen_0_Choose_one_0: "${form.Choose_one}",
                    screen_0_Leave_a_comment_1: "${form.Leave_a_comment}",
                  },
                },
              },
            ],
          },
        ],
      },
    },
    {
      id: "RATE",
      title: "Feedback 2 of 2",
      data: {
        screen_0_Choose_one_0: {
          type: "string",
          __example__: "Example",
        },
        screen_0_Leave_a_comment_1: {
          type: "string",
          __example__: "Example",
        },
      },
      terminal: true,
      success: true,
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "Form",
            name: "form",
            children: [
              {
                type: "TextSubheading",
                text: "Rate the following: ",
              },
              {
                type: "Dropdown",
                label: "Purchase experience",
                required: true,
                name: "Purchase_experience",
                "data-source": [
                  {
                    id: "0_Excellent",
                    title: "★★★★★ • Excellent (5/5)",
                  },
                  {
                    id: "1_Good",
                    title: "★★★★☆ • Good (4/5)",
                  },
                  {
                    id: "2_Average",
                    title: "★★★☆☆ • Average (3/5)",
                  },
                  {
                    id: "3_Poor",
                    title: "★★☆☆☆ • Poor (2/5)",
                  },
                  {
                    id: "4_Very_Poor",
                    title: "★☆☆☆☆ • Very Poor (1/5)",
                  },
                ],
              },
              {
                type: "Dropdown",
                label: "Delivery and setup",
                required: true,
                name: "Delivery_and_setup",
                "data-source": [
                  {
                    id: "0_Excellent",
                    title: "★★★★★ • Excellent (5/5)",
                  },
                  {
                    id: "1_Good",
                    title: "★★★★☆ • Good (4/5)",
                  },
                  {
                    id: "2_Average",
                    title: "★★★☆☆ • Average (3/5)",
                  },
                  {
                    id: "3_Poor",
                    title: "★★☆☆☆ • Poor (2/5)",
                  },
                  {
                    id: "4_Very_Poor",
                    title: "★☆☆☆☆ • Very Poor (1/5)",
                  },
                ],
              },
              {
                type: "Dropdown",
                label: "Customer service",
                required: true,
                name: "Customer_service",
                "data-source": [
                  {
                    id: "0_Excellent",
                    title: "★★★★★ • Excellent (5/5)",
                  },
                  {
                    id: "1_Good",
                    title: "★★★★☆ • Good (4/5)",
                  },
                  {
                    id: "2_Average",
                    title: "★★★☆☆ • Average (3/5)",
                  },
                  {
                    id: "3_Poor",
                    title: "★★☆☆☆ • Poor (2/5)",
                  },
                  {
                    id: "4_Very_Poor",
                    title: "★☆☆☆☆ • Very Poor (1/5)",
                  },
                ],
              },
              {
                type: "Footer",
                label: "Done",
                "on-click-action": {
                  name: "complete",
                  payload: {
                    screen_1_Purchase_experience_0:
                      "${form.Purchase_experience}",
                    screen_1_Delivery_and_setup_1: "${form.Delivery_and_setup}",
                    screen_1_Customer_service_2: "${form.Customer_service}",
                    screen_0_Choose_one_0: "${data.screen_0_Choose_one_0}",
                    screen_0_Leave_a_comment_1:
                      "${data.screen_0_Leave_a_comment_1}",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
};

const SEND_SURVEY_TEMPLATE = {
  version: "7.2",
  screens: [
    {
      id: "QUESTION_ONE",
      title: "Question 1 of 3",
      data: {},
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "Form",
            name: "form",
            children: [
              {
                type: "TextHeading",
                text: "You've found the perfect deal, what do you do next?",
              },
              {
                type: "CheckboxGroup",
                label: "Choose that apply:",
                required: true,
                name: "Choose_all_that_apply_0",
                "data-source": [
                  {
                    id: "0_Buy_it_right_away",
                    title: "Buy it right away",
                  },
                  {
                    id: "1_Check_reviews_before_buying",
                    title: "Check reviews before buying",
                  },
                  {
                    id: "2_Share_it_with_friends_family",
                    title: "Share it with friends + family",
                  },
                  {
                    id: "3_Buy_multiple_while_its_cheap",
                    title: "Buy multiple, while its cheap",
                  },
                  {
                    id: "4_None_of_the_above",
                    title: "None of the above",
                  },
                ],
              },
              {
                type: "Footer",
                label: "Continue",
                "on-click-action": {
                  name: "navigate",
                  next: {
                    type: "screen",
                    name: "QUESTION_TWO",
                  },
                  payload: {
                    screen_0_Choose_all_that_apply_0:
                      "${form.Choose_all_that_apply_0}",
                  },
                },
              },
            ],
          },
        ],
      },
    },
    {
      id: "QUESTION_TWO",
      title: "Question 2 of 3",
      data: {
        screen_0_Choose_all_that_apply_0: {
          type: "array",
          items: {
            type: "string",
          },
          __example__: [],
        },
      },
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "Form",
            name: "form",
            children: [
              {
                type: "TextHeading",
                text: "Its your birthday in two weeks, how might you prepare?",
              },
              {
                type: "RadioButtonsGroup",
                label: "Choose one:",
                required: true,
                name: "Choose_one_0",
                "data-source": [
                  {
                    id: "0_Buy_something_new",
                    title: "Buy something new",
                  },
                  {
                    id: "1_Wear_the_same_as_usual",
                    title: "Wear the same, as usual",
                  },
                  {
                    id: "2_Look_for_a_deal_online",
                    title: "Look for a deal online",
                  },
                ],
              },
              {
                type: "Footer",
                label: "Continue",
                "on-click-action": {
                  name: "navigate",
                  next: {
                    type: "screen",
                    name: "QUESTION_THREE",
                  },
                  payload: {
                    screen_1_Choose_one_0: "${form.Choose_one_0}",
                    screen_0_Choose_all_that_apply_0:
                      "${data.screen_0_Choose_all_that_apply_0}",
                  },
                },
              },
            ],
          },
        ],
      },
    },
    {
      id: "QUESTION_THREE",
      title: "Question 3 of 3",
      data: {
        screen_1_Choose_one_0: {
          type: "string",
          __example__: "Example",
        },
        screen_0_Choose_all_that_apply_0: {
          type: "array",
          items: {
            type: "string",
          },
          __example__: [],
        },
      },
      terminal: true,
      success: true,
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "Form",
            name: "form",
            children: [
              {
                type: "TextHeading",
                text: "What's the best gift for a friend?",
              },
              {
                type: "CheckboxGroup",
                label: "Choose that apply:",
                required: true,
                name: "Choose_all_that_apply_0",
                "data-source": [
                  {
                    id: "0_A_gift_voucher",
                    title: "A gift voucher",
                  },
                  {
                    id: "1_A_new_outfit",
                    title: "A new outfit ",
                  },
                  {
                    id: "2_A_boquet_of_flowers",
                    title: "A bouquet of flowers",
                  },
                  {
                    id: "3_A_meal_out_together",
                    title: "A meal out together",
                  },
                ],
              },
              {
                type: "Footer",
                label: "Done",
                "on-click-action": {
                  name: "complete",
                  payload: {
                    screen_0_Choose_all_that_apply_0:
                      "${data.screen_0_Choose_all_that_apply_0}",
                    screen_1_Choose_one_0: "${data.screen_1_Choose_one_0}",
                    screen_2_Choose_all_that_apply_0:
                      "${form.Choose_all_that_apply_0}",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
};

const CUSTOMER_SUPPORT_TEMPLATE = {
  version: "7.2",
  screens: [
    {
      id: "DETAILS",
      title: "Get help",
      data: {},
      terminal: true,
      success: true,
      layout: {
        type: "SingleColumnLayout",
        children: [
          {
            type: "Form",
            name: "form",
            children: [
              {
                type: "TextInput",
                name: "Name",
                label: "Name",
                "input-type": "text",
                required: true,
              },
              {
                type: "TextInput",
                label: "Order number",
                name: "Order_number",
                "input-type": "number",
                required: true,
              },
              {
                type: "RadioButtonsGroup",
                label: "Choose a topic",
                name: "Choose_a_topic",
                "data-source": [
                  {
                    id: "0_Orders_and_payments",
                    title: "Orders and payments",
                  },
                  {
                    id: "1_Maintenance",
                    title: "Maintenance",
                  },
                  {
                    id: "2_Delivery",
                    title: "Delivery",
                  },
                  {
                    id: "3_Returns",
                    title: "Returns",
                  },
                  {
                    id: "4_Other",
                    title: "Other",
                  },
                ],
                required: true,
              },
              {
                type: "TextArea",
                label: "Description of issue",
                required: false,
                name: "Description_of_issue",
              },
              {
                type: "Footer",
                label: "Done",
                "on-click-action": {
                  name: "complete",
                  payload: {
                    screen_0_Name_0: "${form.Name}",
                    screen_0_Order_number_1: "${form.Order_number}",
                    screen_0_Choose_a_topic_2: "${form.Choose_a_topic}",
                    screen_0_Description_of_issue_3:
                      "${form.Description_of_issue}",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
};

export const FLOW_TEMPLATE_OPTIONS = {
  WITHOUT_ENDPOINT: [
    { label: "Default", value: "DEFAULT", template: DEFAULT_TEMPLATE },
    {
      label: "Collect purchase interest",
      value: "COLLECT_PURCHASE_INTEREST",
      template: COLLECT_PURCHASE_INTEREST_TEMPLATE,
    },
    {
      label: "Get feedback",
      value: "GET_FEEDBACK",
      template: GET_FEEDBACK_TEMPLATE,
    },
    {
      label: "Send a survey",
      value: "SEND_SURVEY",
      template: SEND_SURVEY_TEMPLATE,
    },
    {
      label: "Customer support",
      value: "CUSTOMER_SUPPORT",
      template: CUSTOMER_SUPPORT_TEMPLATE,
    },
  ],
  WITH_ENDPOINT: [
    {
      label: "Get leads for a pre-approved loan / credit card",
      value: "GET_LEADS_FOR_PRE_APPROVED_LOAN",
      // template: GET_LEADS_FOR_PRE_APPROVED_LOAN_TEMPLATE,
      template: DEFAULT_TEMPLATE,
      disabled: true,
    },
    {
      label: "Provide insurance quote",
      value: "PROVIDE_INSURANCE_QUOTE",
      // template: PROVIDE_INSURANCE_QUOTE_TEMPLATE,
      template: DEFAULT_TEMPLATE,
      disabled: true,
    },
    {
      label: "Capture interest for a personalized offer",
      value: "CAPTURE_INTEREST_FOR_PERSONALIZED_OFFER",
      // template: CAPTURE_INTEREST_FOR_PERSONALIZED_OFFER_TEMPLATE,
      template: DEFAULT_TEMPLATE,
      disabled: true,
    },
    {
      label: "Account Sign in / Sign up",
      value: "ACCOUNT_SIGN_IN_SIGN_UP",
      // template: ACCOUNT_SIGN_IN_SIGN_UP_TEMPLATE,
      template: DEFAULT_TEMPLATE,
      disabled: true,
    },
    {
      label: "Appointment booking",
      value: "APPOINTMENT_BOOKING",
      // template: APPOINTMENT_BOOKING_TEMPLATE,
      template: DEFAULT_TEMPLATE,
      disabled: true,
    },
  ],
};
